<template>
	<el-container>
		<Menu :activeIndex='activeIndex'></Menu>
		<el-container>
			<el-header>
				<h2>课程管理</h2>
				<el-button size="medium" plain type="success" id='btn_add' @click="dialogFormVisible = true,clearform()" v-if="roleId == 1">新建课程</el-button>
			</el-header>
			<el-main>
				<!-- 表格 -->
				<el-table :data="tableData" :stripe="true" :border='true' :default-sort="{prop: 'date', order: 'descending'}">
					<el-table-column label="序号" width="50" :maxlength="100" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align:center;" v-text="scope.row.sort"></div>
						</template>
					</el-table-column>
					<el-table-column prop="src" label="封面" style="" width="100">
						<template slot-scope="scope">
							<img :src="scope.row.src" alt="" style="width: 50px;margin-top:5px;">
						</template>
					</el-table-column>
					<el-table-column label="发布状态" style="" width="100">
						<template slot-scope="scope">
							<p v-if='scope.row.fabu==1'>已发布</p>
							<p v-if='scope.row.fabu!=1' style="color:#d00;">未发布</p>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="课程名称" style="" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<span class="Saveid" @click="Openlessons(scope.$index, scope.row),dialoglessonsVisible = true" v-html="scope.row.name"></span>
						</template>
					</el-table-column>
					<el-table-column label="课程分类" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div v-for="(item,index) in classifyData" :key="index" v-if="item.id == scope.row.category" v-text="item.name"></div>
						</template>
					</el-table-column>
					<el-table-column label="课程链接" style="" :show-overflow-tooltip="true" width="350">
						<template slot-scope="scope">
							<span v-text="'https://uni.guanqimiao.cn/pages/buy/buy?courseId='+scope.row.id"></span>
						</template>
					</el-table-column>
					<el-table-column label="课程二维码" style="" width="120">
						<template slot-scope="scope">
							<!--<img :src="scope.row.src" alt="" style="width: 50px;margin-top:5px;">-->
							<qrcode-vue :value="'https://uni.guanqimiao.cn/pages/buy/buy?courseId='+scope.row.id" size="100" level="H"></qrcode-vue>
						</template>
					</el-table-column>
					<!--<el-table-column prop="category" label="类型" :show-overflow-tooltip="true">
					</el-table-column>-->
					<el-table-column prop="courselength" width="100" label="课程时长" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="price" width="100" label="价格">
					</el-table-column>
          <el-table-column prop="oldPrice" width="100" label="原价">
          </el-table-column>
					<el-table-column prop="standard" width="100" label="奖励限定" :maxlength="200" :show-overflow-tooltip="true">
					</el-table-column>

					<!-- <el-table-column prop="start" label="开始日期"  :maxlength="200" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="end" label="结束日期"  :maxlength="200" :show-overflow-tooltip="true">
              </el-table-column> -->
					<el-table-column label="操作" width="150">
						<template slot-scope="scope">
							<el-button-group>
								<el-button type="primary" size="mini" plain @click="handleEdit(scope.$index, scope.row),dialogFormVisible = true">编辑</el-button>
								<!--<el-button size="mini" plain type="danger" @click="handleDelete(tableData, scope.row,scope.$index)">删除</el-button>-->
							</el-button-group>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" background :page-size="9" layout="prev, pager, next, jumper" :total="pageTotal">
				</el-pagination>
			</el-main>
			<el-footer>Copyright &copy; Soren经济学人 技术支持 ：
				<a href="#">Soren团队</a>
			</el-footer>
		</el-container>
		<el-dialog title="信息编辑" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
			<el-form :model="form" ref="form">
				<el-form-item label="封面" :label-width="formLabelWidth">
					<el-upload class="avatar-uploader" :action="UploadUrl()" :http-request='submitLogoUpload' :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
						<img v-if="form.src" :src="form.src" class="avatar" style="width:200px;">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="课程序号" :label-width="formLabelWidth">
					<el-input v-model.number="form.sort" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="课程名称" :label-width="formLabelWidth">
					<el-input v-model="form.name" auto-complete="off"></el-input>
				</el-form-item>
        <el-form-item label="课程模式" :label-width="formLabelWidth">
          <el-select v-model="form.model" placeholder="请选择" @change="getClassify">
            <el-option v-for="item in classModelData" :key="item.id" :label="item.desc" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
				<el-form-item label="发布状态" :label-width="formLabelWidth">
					<el-switch v-model="form.fabu" active-color="#13ce66" inactive-color="#ff4949" active-text="发布" active-value="1" inactive-value="0">
					</el-switch>
				</el-form-item>
				<el-form-item label="课程分类" :label-width="formLabelWidth">
					<!--<el-input v-model="form.category" auto-complete="off"></el-input>-->
					<el-select v-model="form.category" placeholder="请选择" @change="getClassify">
						<el-option v-for="item in classifyData" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="课程时长" :label-width="formLabelWidth" prop="courselength" :rules="[
      { required: true, message: '课程时长不能为空'},
      { type: 'number', message: '课程时长必须为数字值'}
    ]">
					<el-input v-model.number="form.courselength" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="价格" :label-width="formLabelWidth" prop="price" :rules="[
      { required: true, message: '价格不能为空'},
      { type: 'number', message: '价格必须为数字值'}
    ]">
					<el-input v-model.number="form.price" auto-complete="off"></el-input>
				</el-form-item>
        <el-form-item label="原价" :label-width="formLabelWidth" prop="oldPrice" :rules="[
      { type: 'number', message: '价格必须为数字值'}
    ]">
          <el-input v-model.number="form.oldPrice" auto-complete="off"></el-input>
        </el-form-item>
				<el-form-item label="奖励限定" :label-width="formLabelWidth" prop="standard" :rules="[
              { required: true, message: '奖励限定不能为空'},
              { type: 'number', message: '奖励限定必须为数字值'}
            ]">
					<el-input v-model.number="form.standard" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="简介" :label-width="formLabelWidth">
					<!--<el-input type="textarea" v-model="form.profile" autosize auto-complete="off"></el-input>-->
					<vue-editor v-model="form.profile" useCustomImageHandler @image-added="handleImageAdded" :editorToolbar="customToolbar"></vue-editor>
				</el-form-item>

				<!-- <el-form-item label="开始日期" :label-width="formLabelWidth">
              <el-date-picker
                v-model="form.start"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期" :label-width="formLabelWidth">
              <el-date-picker
                v-model="form.end"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </el-form-item>           -->
				<el-form-item label="班长二维码" :label-width="formLabelWidth">
					<el-upload class="avatar-uploader" :action="UploadUrl()" :http-request='submitcodeUpload' :show-file-list="false" :on-success="codehandleAvatarSuccess" :before-upload="beforeAvatarUpload">
						<img v-if="form.monitorqrcode" :src="form.monitorqrcode" class="avatar" style="width:200px;">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<el-button v-on:click="del_monitorCode">删除二维码</el-button>
				</el-form-item>
        <el-form-item label="期末总结" :label-width="formLabelWidth">
          <el-input v-model="form.zongjie" auto-complete="off" placeholder="格式：reDian=3;huaTi=4"></el-input>
        </el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogFormVisible = false,submitForm('form')">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="课时管理" :visible.sync="dialoglessonsVisible" width="90%" :close-on-click-modal="false">
			<div slot="title" class="dialog-title">
				课时管理
				<el-button size="medium" plain type="success" id='btn_add' @click="dialoglessons = true,clearlessons()">新建课时</el-button>
			</div>

			<el-table :data="lessonsData" style="width: 100%;" :stripe="true" :border='true' :default-sort="{prop: 'date', order: 'descending'}">
				<el-table-column prop="title" label="标题" :show-overflow-tooltip="true">
				</el-table-column>
				<!--<el-table-column prop="name" label="名称" style="" :show-overflow-tooltip="true"></el-table-column>-->
				<el-table-column prop="profile" label="简介" :maxlength="200" :show-overflow-tooltip="true">
				</el-table-column>
				<!--<el-table-column prop="author" label="作者" :maxlength="200" :show-overflow-tooltip="true">
				</el-table-column>-->
				<el-table-column label="详情页背景" width="200">
					<template slot-scope="scope">
						<img :src="scope.row.author" class="avatar">
					</template>

				</el-table-column>
				<el-table-column label="操作" width="280">
					<template slot-scope="scope">
						<el-button-group>
							<el-button type="primary" size="mini" plain @click="lessonsEdit(scope.$index, scope.row),dialoglessons = true">编辑</el-button>
							<el-button type="warning" size="mini" plain @click="HomeworkListEdit(scope.$index, scope.row),dialogHomeworkList = true">课后题</el-button>
							<el-button type="success" size="mini" plain @click="reviewListEdit(scope.$index, scope.row),reviewState = true">复习题</el-button>
              <el-button type="primary" size="mini" plain @click="downloadLessons(scope.$index, scope.row)">导出</el-button>
							<!--<el-button size="mini" plain type="danger" @click="lessonsDelete(tableData, scope.row,scope.$index)">删除</el-button>-->
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @size-change="handleSizeChange" @current-change="handlelessonsChange" :current-page.sync="lessonsPage" background :page-size="9" layout="prev, pager, next, jumper" :total="pageTolessons">
			</el-pagination>

		</el-dialog>

		<el-dialog title="课时编辑" :visible.sync="dialoglessons" width="1000px" :close-on-click-modal="false">

<!--			<div class="showPrevData">
				<el-button class="prve_btn" size="small" type="primary">恢复之前数据</el-button>
			</div>-->
			<el-form :model="lessonsform">
				<!--<el-form-item label="名称" :label-width="formLabelWidth">
					<el-input v-model="lessonsform.name" auto-complete="off"></el-input>
				</el-form-item>-->
				<el-form-item label="标题" :label-width="formLabelWidth">
					<el-input v-model="lessonsform.title" auto-complete="off"></el-input>
				</el-form-item>
				<!--<el-form-item label="作者" :label-width="formLabelWidth">
					<el-input v-model="lessonsform.author" auto-complete="off"></el-input>
				</el-form-item>-->
				<el-form-item label="详情页背景" :label-width="formLabelWidth">
					<el-upload class="avatar-uploader" :multiple="false" :show-file-list="false" style="border:0;float: left;" ref="upload" :action="UploadUrl()" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccessBg" :auto-upload="true">
						<img v-if="lessonsform.author" :src="lessonsform.author" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
        <el-form-item label="详情页背景链接" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="lessonsform.author" autosize auto-complete="off"></el-input>
        </el-form-item>
				<el-form-item label="序列" :label-width="formLabelWidth">
					<el-input v-model="lessonsform.sort" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="简介" :label-width="formLabelWidth">
					<el-input type="textarea" v-model="lessonsform.profile" autosize auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="上传音频" class='clearfix' :label-width="formLabelWidth">
					<!--<el-button size="small" type="primary">点击上传</el-button>-->
					<el-upload class="upload-demo el_part" :multiple="false" :show-file-list="false" style="border:0;float: left;" ref="upload" :action="UploadUrl()" :before-upload="beforeAvatarUploadMusic" :on-success="handleAvatarSuccessMusic" :auto-upload="true">
						<el-button slot="trigger" size="small" type="primary">点击上传</el-button>
					</el-upload>
					<audio style="float:left;margin-left: 20px;" :src="lessonsform.content" controls="controls"></audio>
				</el-form-item>
				<el-form-item label="音频" :label-width="formLabelWidth">
					<el-input type="textarea" v-model="lessonsform.content" autosize auto-complete="off"></el-input>
				</el-form-item>
        <el-form-item label="视频" :label-width="formLabelWidth">
					<el-input type="textarea" v-model="lessonsform.video" autosize auto-complete="off"></el-input>
				</el-form-item>
        <el-form-item label="创建日期" :label-width="formLabelWidth">
          <el-date-picker v-model="lessonsform.createtime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期" style="width: 30%;"></el-date-picker>
        </el-form-item>
				<!--<vue-editor v-model="lessonsform.content" useCustomImageHandler
      @imageAdded="handleImageAdded" :editorToolbar="customToolbar"></vue-editor>   -->
				<div class="_detail">
					<h2>课程详情</h2>
					<div v-for="(item,index) in conBox" style="position:relative;">
						<i class="el-icon-delete" v-on:click='delateDetail(item.id,index)'></i>
						<el-form-item label="序号" :label-width="formLabelWidth">
							<el-input v-model="item.sort" auto-complete="off"></el-input>
						</el-form-item>
						<el-form-item label="英文原文" :label-width="formLabelWidth">
							<!--<el-input type="textarea" v-model="item.en_content" autosize auto-complete="off"></el-input>-->
							<vue-editor v-model="item.en_content" @text-change="handTextAdded" useCustomImageHandler @image-added="handleImageAdded" :editorToolbar="customToolbar"></vue-editor>
						</el-form-item>
						<el-form-item label="解析" :label-width="formLabelWidth">
							<!--<el-input type="textarea" v-model="item.ch_content" autosize auto-complete="off"></el-input>-->
<!--							<vue-editor v-model="item.ch_content" useCustomImageHandler @image-added="handleImageAdded" :editorToolbar="customToolbar"></vue-editor>-->
              <tiny-mce v-model="item.ch_content"></tiny-mce>
            </el-form-item>
					</div>
				</div>

				<div style="text-align:center;" v-on:click="addMoreDetail">
					<el-button type="success" plain>更多详情</el-button>
				</div>

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="dialoglessons = false">取 消</el-button>
				<el-button type="primary" @click="dialoglessons = false,submitlessons(lessonsform)">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="课后题管理" :visible.sync="dialogHomeworkList" width="80%">
			<el-row :gutter="20">
				<el-col :span="24">
					<el-button size="medium" plain type="success" @click="dialogHomework = true,clearHomeworkList()">新建课后题</el-button>
					<el-table :data="HomeworkListData" style="width: 100%;margin-top:10px" :stripe="true" :border='true' :default-sort="{prop: 'date', order: 'descending'}">
						<!--@current-change="handleHomeworkDataChange"-->
						<el-table-column prop="sort" label="问题" style="" :show-overflow-tooltip="true"></el-table-column>
						<el-table-column prop="question" label="问题" style="" :show-overflow-tooltip="true"></el-table-column>
						<el-table-column prop="answer" label="答案" :maxlength="200" :show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column prop="analysis" label="解析" :maxlength="200" :show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column label="操作" width="200">
							<template slot-scope="scope">
								<el-button-group>
									<el-button type="primary" size="mini" plain @click="HomeworkEdit(scope.$index, scope.row),dialogHomework = true">编辑</el-button>
									<!--<el-button size="mini" plain type="danger" @click="HomeworkDelete(tableData, scope.row,scope.$index)">删除</el-button>-->
								</el-button-group>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
		</el-dialog>
		<el-dialog title="复习题管理" :visible.sync="reviewState" width="80%" :close-on-click-modal="false">
			<el-row :gutter="20">
				<el-col :span="24">
					<el-button size="medium" plain type="success" @click="editReviewState = true,addreviewData()">新建复习题</el-button>
					<el-table :data="reviewListData" style="width: 100%;margin-top:10px" :stripe="true" :border='true'>
						<el-table-column prop="sort" label="序号" width="50" :show-overflow-tooltip="true"></el-table-column>
						<el-table-column label="复习内容" :show-overflow-tooltip="false">
							<template slot-scope="scope">
								<div v-html="scope.row.en_content"></div>
							</template>
						</el-table-column>
						<el-table-column label="解析" :show-overflow-tooltip="false">
							<template slot-scope="scope">
								<div v-html="scope.row.ch_content"></div>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="150">
							<template slot-scope="scope">
								<el-button-group>
									<el-button type="primary" size="mini" plain @click="reviewDataEdit(scope.$index, scope.row),editReviewState = true">编辑</el-button>
									<!--<el-button size="mini" plain type="danger" @click="reviewDelete(scope.row.id,scope.$index)">删除</el-button>-->
								</el-button-group>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
		</el-dialog>
		<el-dialog title="选项编辑" :visible.sync="editReviewState" width="70%" :close-on-click-modal="false">
			<el-form :model="Homeworkform">
				<el-form-item label="序号" label-width="50px">
					<el-input v-model="editReviewData.sort" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="内容" label-width="50px">
					<vue-editor v-model="editReviewData.en_content" useCustomImageHandler @image-added="handleImageAdded" :editorToolbar="customToolbar"></vue-editor>
				</el-form-item>
				<el-form-item label="解析" label-width="50px">
					<vue-editor v-model="editReviewData.ch_content" useCustomImageHandler @image-added="handleImageAdded" :editorToolbar="customToolbar"></vue-editor>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editReviewState = false">取 消</el-button>
				<el-button type="primary" @click="submitreview()">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="选项编辑" :visible.sync="dialogHomework">
			<el-form :model="Homeworkform">
				<el-form-item label="序号" :label-width="formLabelWidth">
					<el-input v-model="Homeworkform.sort" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="问题" :label-width="formLabelWidth">
					<el-input v-model="Homeworkform.question" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="答案" :label-width="formLabelWidth">
					<el-input v-model="Homeworkform.answer" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="解析" :label-width="formLabelWidth">
					<el-input v-model="Homeworkform.analysis" auto-complete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogHomework = false">取 消</el-button>
				<el-button type="primary" @click="dialogHomework = false,submitHomework(Homeworkform)">确 定</el-button>
			</div>
		</el-dialog>
		<div class="load_page" v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-customClass="load_icon" v-show="loading"></div>
	</el-container>

</template>

<script>
	import { VueEditor } from "vue2-editor";
	import QrcodeVue from 'qrcode.vue';
  import tinyMce from "./tinymce.vue";

  export default {
		data() {
			return {
				activeIndex: "1",
				tableData: [],
				lessonsData: [],
				HomeworkListData: [],
				pageTotal: 1,
				currentPage: 1,
				lessonsPage: 1,
				pageTolessons: 1,
				dialogFormVisible: false,
				dialoglessonsVisible: false,
				dialoglessons: false,
				dialogHomeworkList: false,
				dialogHomework: false,
				dialogoptions: false,
				form: {
					id: "",
					name: "",
					src: "",
					category: "",
					courselength: "",
					price: "",
          oldPrice:"",
					standard: "",
					profile: "",
					start: "",
					end: "",
					mark: localStorage.getItem("mark"),
					monitorqrcode: '',
					sort: 0,
					fabu:'0',
          model:1,
          zongjie :""
				},
				lessonsform: {
					author: "",
					content: "",
          video : "",
					lessonDetail: [],
					courseid: "",
					id: "",
					name: "",
					profile: "",
					sort: "",
					title: "",
					mark: 'xueqiu',
          createtime:""
				},
				formLabelWidth: "120px",
				courseid: "",
				customToolbar: [
					["bold", "italic", "underline", "strike","blockquote"],
					["image",'link','video'],
          [{'list': 'ordered'}, {'list': 'bullet' }, {'list': 'check' }],
					[{
						color: []
					}, {
						background: []
					}],
					[{
						font: []
					}],
					[{
						align: []
					}],
					[{
						header: 1
					}, {
						header: 2
					}],
					[{
						header: [1, 2, 3, 4, 5, 6, false]
					}],
					[{
						size: ["small", false, "large", "huge"]
					}]
				],
				Homeworkform: {
					question: "",
					sort: "",
					detailid: "",
					id: "",
					fid: '',
					answer: "",
					analysis: "",
					mark: localStorage.getItem("mark")
				},
				optionsform: {
					sort: "",
					state: "",
					id: "",
					fid: "",
					abcd: "",
					mark: localStorage.getItem("mark")
				},
				loading: true,
				conBox: [],
				reviewState: false,
				reviewListData: [],
				editReviewState: false,
				editReviewData: {},
				classifyData: [],
        classModelData:[
          {'id':1,'desc':'随报随学'},{'id':2,'desc':'逢8开课'},{'id':3,'desc':'闯关模式'},{'id':4,'desc':'其它模式备用'}
        ],
        roleId : localStorage.getItem("roleId")  //权限ID
			};
		},
		created() {
			this.getData(this.currentPage);
			this.getClassifyData();
		},
		updated: function() {
			this.ifHavemark();
		},
		components: {
			VueEditor,
			QrcodeVue,
      tinyMce
		},
		methods: {
			getClassify: function(val) {
				//console.log(val);
				//console.log(this.form.category)
			},
			reviewDelete: function(id, index) {
				/*var that = this;
				that.$confirm("确认删除该复习内容?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(() => {
						that.loading = true;
						that.axios.post('/lessonsReview/delete', {
							'id': id
						}).then((res) => {
							//talkState = 1;
							if(res.data.code == 600) {
								//that.loading = false;
								//that.reviewListData.splice(index,1)
								var timer = setTimeout(() => {
									that.getreviewData();
									clearInterval(timer);
								}, 100);
							}
						}).then((result) => {

						})
					})*/
			},
			addreviewData: function() {
				var that = this;
				that.editReviewData = {
					index: -1,
					ch_content: '',
					en_content: '',
					sort: ''
				}
				//that.reviewListData.push(that.editReviewData)
			},
			submitreview: function() {
				var that = this;
				var temp = that.reviewListData;
				if(that.editReviewData.index == -1) {
					that.editReviewData.index = that.reviewListData.length;
					temp.push(that.editReviewData)
				}
				temp[that.editReviewData.index].ch_content = that.editReviewData.ch_content;
				temp[that.editReviewData.index].en_content = that.editReviewData.en_content;
				temp[that.editReviewData.index].sort = that.editReviewData.sort;

				that.loading = true;
				that.axios.post('/lessonsReview/add', {
					'lessonsid': that.lessonsform.id,
					"lessonsReview": JSON.stringify(temp)
				}).then((res) => {
					//talkState = 1;
					if(res.data.code == 600) {
						//that.loading = false;
						that.editReviewState = false;
						that.editReviewData = {};
						var timer = setTimeout(() => {
							that.getreviewData();
							clearInterval(timer);
						}, 100);
					} else {
						that.$message({
							type: "error",
							message: "操作失败"
						});
					}
				}).then((result) => {

				})
			},
			reviewDataEdit: function(index, info) {
				var that = this;
				that.editReviewData = {
					index: index,
					ch_content: info.ch_content,
					en_content: info.en_content,
					sort: info.sort
				}
				console.log(that.editReviewData.index);
			},
			getreviewData: function() {
				var that = this;
				that.loading = true;
				that.axios.post('/lessonsReview/list', {
					'mark': 'xueqiu',
					"lessonsid": that.lessonsform.id
				}).then((res) => {
					//talkState = 1;
					if(res.data.code == 600) {
						that.loading = false;
						that.reviewListData = res.data.data;
					}
				}).then((result) => {

				})
			},
			del_monitorCode: function() { //删除班长二维码
				var that = this;
				that.form.monitorqrcode = "";
			},
			beforeAvatarUploadMusic: function(file) {
				var that = this;
				const isMP3 = file.type === 'audio/mp3';
				const isMAV = file.type === 'audio/mav';
				const isLt2M = file.size / 1024 / 1024 < 10;
				if(!isMP3 && !isMAV) {
					that.$message({
						message: '上传音频必须是mp3/mav',
						type: 'warning'
					});
				}
				if(!isLt2M) {
					that.$message({
						message: '上传音频大小不能超过 10MB!',
						type: 'warning'
					});
				}
				if(isMP3 || isMAV && isLt2M) {
					that.loading = true;
				}
				return(isMP3 || isMAV) && isLt2M;
			},
			handleAvatarSuccessMusic: function(response, file, fileList) {
				var that = this;
				//console.log(response);
				if(response.code == 600) {
					that.loading = false;
					that.$message({
						message: '上传成功',
						type: 'success'
					});
					that.lessonsform.content = response.data;
				} else {
					that.loading = false;
					that.$message({
						message: '上传失败',
						type: 'warning'
					});
				}
			},
			// 页面 表格数据 初始化
			getData(page) {
				var self = this;
				self.loading = true;
				let requestPage = page;
        let roleId = localStorage.getItem('roleId');
				if(roleId == 2){
          requestPage = 1;  //根据权限ID判断请求第多少页，临时这么做，后面重写接口。
        }
				self.axios.post('/course/list', {
						mark: localStorage.getItem("mark"),
						page: requestPage
					})
					.then(function(response) {
						//console.log(response);
						if(response.data.code == "600") {
							self.loading = false;
							/**
               * 根据roleID对数据进行处理，如果roleId为2，那么就只显示
               * */
							let roleTableData = [];
							if(roleId == 2){
                roleTableData = response.data.data.filter(function(course){
                    if(course.category == 10){
                      return course;
                    }else{
                      return null;
                    }
                  });
                self.tableData = roleTableData;
                  self.pageTotal = 1;
              }else{
                self.tableData = response.data.data;
                self.pageTotal = response.data.dataTotal;
              }
						} else if(response.data.code == "400") {
							self.$message({
								type: "error",
								message: "操作失败"
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			UploadUrl: function() {
				return "https://console.sorenenglish.com/api/file/uploadLogo";
			},
			getDatalessons(page, courseid) {
				var self = this;
				self.axios.post('/lessons/list', {
						mark: localStorage.getItem("mark"),
						page: page,
						courseid: courseid
					})
					.then(function(response) {
						if(response.data.code == "600") {
							self.lessonsData = response.data.data;
							self.pageTolessons = response.data.dataTotal;
						} else if(response.data.code == "400") {
							self.$message({
								type: "error",
								message: "操作失败"
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			//分页  区域  start
			handleSizeChange(val) {
				//console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				var self = this;
				// console.log(`当前页: ${val}`);
				self.currentPage = val;
				self.getData(this.currentPage);
			},

			handlelessonsChange(val) {
				var self = this;
				// console.log(`当前页: ${val}`);
				self.lessonsPage = val;
				self.getDatalessons(self.lessonsPage, self.courseid);
			},
			Openlessons(index, row) {
				var self = this;
				self.courseid = row.id;
				self.getDatalessons(self.lessonsPage, self.courseid);
			},
			//分页  区域  end
			submitLogoUpload(content) {
				console.log(content);
				var self = this;
				//1. 创建formData 利用AXIOS传递
				let formData = new FormData();
				formData.append("file", content.file);
				let config = {
					"Content-Type": "multipart/form-data"
				};
				let var_this = this;
				self.axios.post("/file/uploadLogo", formData, config)
					.then(function(response) {
						//console.log(response);
						self.form.src = response.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			handleAvatarSuccessBg: function(res, file) {
				var that = this;
				if(res.code == 600) {
					that.lessonsform.author = res.data;
					that.$message({
						message: '上传成功',
						type: 'success'
					});
				} else {
					that.$message({
						message: '上传失败，请重新上传',
						type: 'warning'
					});
				}
			},
			submitcodeUpload(content) {
				console.log(content);
				var self = this;
				//1. 创建formData 利用AXIOS传递
				let formData = new FormData();
				formData.append("file", content.file);
				let config = {
					"Content-Type": "multipart/form-data"
				};
				let var_this = this;
				self.axios.post("/file/uploadLogo", formData, config)
					.then(function(response) {
						//console.log(response);
						self.form.monitorqrcode = response.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			handleAvatarSuccess(res, file) {
				this.form.src = res.data;
			},
			codehandleAvatarSuccess(res, file) {
				//console.log(res, file);
				this.form.monitorqrcode = res.data;
			},
			//  beforeAvatarUpload(file) {
			//    const isLt2M = file.size / 1024 / 1024 < 2;
			//    if (!isLt2M) {
			//      this.$message.error("上传头像图片大小不能超过 2MB!");
			//    }
			//    return isLt2M;
			//  },
			beforeAvatarUpload: function(file) {
				var that = this;
				const isJPG = file.type === 'image/jpeg';
				const isGIF = file.type === 'image/gif';
				const isPNG = file.type === 'image/png';
				const isBMP = file.type === 'image/bmp';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if(!isJPG && !isGIF && !isPNG && !isBMP) {
					that.$message({
						message: '上传图片必须是JPG/GIF/PNG/BMP 格式!',
						type: 'warning'
					});
				}
				if(!isLt2M) {
					that.$message({
						message: 'sF上传图片大小不能超过 2MB!',
						type: 'warning'
					});
				}
				return(isJPG || isBMP || isGIF || isPNG) && isLt2M;
			},
			handleEdit(index, row) {
				var self = this;
				self.form.sort = row.sort;
				self.form.id = row.id;
				self.form.name = row.name;
				self.form.src = row.src;
				self.form.category = row.category;
				self.form.courselength = row.courselength;
				self.form.price = row.price;
				self.form.oldPrice = row.oldPrice;
				self.form.standard = row.standard;
				self.form.profile = row.profile;
				self.form.start = row.start;
				self.form.end = row.end;
				self.form.mark = row.mark;
				self.form.monitorqrcode = row.monitorqrcode;
				self.form.fabu = row.fabu;
				self.form.model = row.model
			},
			getClassifyData: function() {
				var that = this;
				that.axios.post("/dict/list", {
						mark: localStorage.getItem("mark")
					})
					.then(function(response) {
						if(response.data.code == "600") {
							that.classifyData = response.data.data;
						} else if(response.data.code == "400") {
							that.$message({
								type: "error",
								message: "操作失败"
							});
						} else {
							that.ifLogin();
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			clearform() {
				var self = this;
				//console.log(row);
				self.form.sort = '';
				self.form.id = "";
				self.form.name = "";
				self.form.src = "";
				self.form.category = "";
				self.form.courselength = "";
				self.form.price = "";
				self.form.oldPrice = "";
				self.form.standard = "";
				self.form.profile = "";
				self.form.start = "";
				self.form.end = "";
				self.form.monitorqrcode = '';
				self.form.fabu = '0';
			},
			handleDelete(rows, row, index) {
				/*var self = this;
				self
					.$confirm("确认删除课程信息?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(() => {
						self.axios.post("/course/delete", {
								mark: localStorage.getItem("mark"),
								id: row.id
							})
							.then(function(response) {
								if(response.data.code == "600") {
									self.$message({
										message: "删除成功",
										type: "success"
									});
									self.getData(self.currentPage);
								} else if(response.data.code == "400") {
									self.$message({
										type: "error",
										message: "操作失败"
									});
								}
							})
							.catch(function(error) {
								console.log(error);
							});
					})
					.catch(() => {
						self.$message({
							type: "info",
							message: "已取消删除"
						});
					});*/
			},
			lessonsEdit(index, row) {
				var self = this;
        self.clearlessons();
				self.loading = true;
				self.axios.post('/lessons/one', {
						id: row.id,
						mark: 'xueqiu'
					}).then(function(response) {
						if(response.data.code == "600") {
							self.loading = false;
							self.lessonsform = response.data.data;
							self.conBox = self.lessonsform.lessonDetail;
							if(response.data.data.lessonDetail == null || response.data.data.lessonDetail.length == 0) {
								self.lessonsform.lessonDetail = [{
									"id": '',
									"lessonsid": self.lessonsform.id,
									"sort": "1",
									"en_content": "",
									"ch_content": "",
									"createtime": "",
									"enable": ""
								}]
							}
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
      downloadLessons(index, row){
        var self = this;
        self.loading = true;
        self.axios.post('/lessons/one', {
          id: row.id,
          mark: 'xueqiu'
        }).then(function(response) {
          if(response.data.code == "600") {
            // 获取课时详情内容
            const lessonData = response.data.data;
            const lessonDetail = lessonData.lessonDetail;

            // 为每个lessonDetail项获取ch_content
            let processedCount = 0;

            for (let i = 0; i < lessonDetail.length; i++) {
              const item = lessonDetail[i];
              //去掉item.en_content的html标签
              item.en_content = item.en_content.replace(/<[^>]+>/g, '');
              //替换 &nbsp; 为空格
              item.en_content = item.en_content.replace(/&nbsp;/g, ' ');
              // 请求API获取ch_content
              self.axios.post('https://soren.guanqimiao.cn/Ai/getAnswer', {
                sentence: item.en_content
              }).then(function(apiResponse) {
                if (apiResponse.data && apiResponse.data.answer) {
                  item.ch_content = apiResponse.data.answer;
                }
                processedCount++;

                // 当所有请求都完成后，下载Word文档
                if (processedCount === lessonDetail.length) {
                  self.loading = false;
                  self.downloadWordFile(lessonData);
                }
              }).catch(function(error) {
                console.error('获取解析内容失败:', error);
                processedCount++;
              });
            }
          }
        })
      },

      // 下载Word文档的辅助方法
      downloadWordFile: function(lessonData) {
        const lessonDetail = lessonData.lessonDetail;

        // 构建Word文档内容
        let wordContent = `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>${lessonData.title}</title>
</head>
<body>
`;
        wordContent += `<h1>${lessonData.title}</h1>\n`;

        // 按顺序添加原文内容(ch_content)和解析内容(en_content)
        if (lessonDetail && lessonDetail.length > 0) {
          lessonDetail.forEach((item, index) => {
            if (item.en_content) {
              wordContent += `<p><strong>句子 ${index + 1}:</strong></p>\n<div>${item.en_content}</div>\n<br/>\n`;
            }
            if (item.ch_content) {
              wordContent += `<p><strong>中文解析 ${index + 1}:</strong></p>\n<div>${item.ch_content}</div>\n<br/>\n`;
              wordContent += `<p>---------------------------------------------------···---------------------------------------------------</p>`
            }
          });
        }

        wordContent += '</body>\n</html>';

        // 创建Blob对象
        const blob = new Blob(['\ufeff', wordContent], { type: 'application/msword' });

        // 创建下载链接
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${lessonData.title}.doc`;

        // 触发下载
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // 释放URL对象
        URL.revokeObjectURL(url);
      },
			clearlessons() {
				var self = this;
				//console.log(row);
				self.lessonsform.author = "";
				self.lessonsform.content = "";
        self.lessonsform.video = "";
        self.lessonsform.createtime = '';
				self.lessonsform.courseid = self.courseid;
				self.lessonsform.id = "";
				self.lessonsform.name = "";
				self.lessonsform.sort = "";
				self.lessonsform.title = "";
				self.lessonsform.profile = "";
				self.conBox = [{
					"id": '',
					"lessonsid": '',
					"sort": 1,
					"en_content": "",
					"ch_content": "",
					"createtime": '',
					"enable": ""
				}]
			},
			lessonsDelete(rows, row, index) {
				/*var self = this;
				self.$confirm("确认删除课时信息?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(() => {
						self.axios.post("/lessons/delete", {
								mark: localStorage.getItem("mark"),
								id: row.id
							})
							.then(function(response) {
								if(response.data.code == "600") {
									self.$message({
										message: "删除成功",
										type: "success"
									});
									self.getDatalessons(self.lessonsPage, self.courseid);
								} else if(response.data.code == "400") {
									self.$message({
										type: "error",
										message: "操作失败"
									});
								}

							})
							.catch(function(error) {
								console.log(error);
							});
					})
					.catch(() => {
						self.$message({
							type: "info",
							message: "已取消删除"
						});
					});*/
			},
			//form 表单 数据
			submitForm(formName) {
				var self = this;
				console.log(self.form);
				self.$refs[formName].validate(valid => {
					if(valid) {
						self.axios.post('/course/add', self.form)
							.then(function(response) {
								if(response.data.code == "600") {
									self.$message({
										message: "添加/编辑成功",
										type: "success"
									});
									self.getData(self.currentPage);
								} else if(response.data.code == "400") {
									self.$message({
										type: "error",
										message: "操作失败"
									});
								}
							})
							.catch(function(error) {
								console.log(error);
							});
					} else {
						self.dialogFormVisible = true,
							console.log("error submit!!");
						return false;
					}
				});
			},
			//form 表单 数据
			submitlessons(formName) {
				var self = this;
				self.loading = true;
				var temp = JSON.stringify(self.conBox);
				var tempparas = formName;
				tempparas.mark = 'xueqiu';
				tempparas.lessonDetail = temp;
				var timer = setTimeout(() => {
					console.log(tempparas);
					self.axios.post(
							"/lessons/add",
							tempparas
						)
						.then(function(response) {
							console.log(response)
							if(response.data.code == "600") {
								self.loading = false;
								self.$message({
									message: "添加/编辑成功",
									type: "success"
								});
								self.getDatalessons(self.lessonsPage, self.courseid);
							} else if(response.data.code == "400") {
								self.$message({
									type: "error",
									message: "操作失败"
								});
							}
							self.lessonsform.lessonDetail = null;
						})
						.catch(function(error) {

						});
				}, 100);

			},

      handTextAdded : function (delta, oldDelta, source){
          console.log(source)
          //console.log(222,oldDelta)
      },

			handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
				var self = this;
				//1. 创建formData 利用AXIOS传递
				let formData = new FormData();
				formData.append("file", file);
				let config = {
					"Content-Type": "multipart/form-data"
				};
				let var_this = this;
				self.axios.post("/file/uploadLogo", formData, config)
					.then(function(result) {
						console.log(result);
						let url = result.data.data; // Get url from response

						Editor.insertEmbed(cursorLocation, "image", url);
						resetUploader();
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			getDataHomeworkList(detailid) {
				var self = this;
				self.axios.post("/homework/list", {
						mark: localStorage.getItem("mark"),
						fid: detailid
					})
					.then(function(response) {
						if(response.data.code == "600") {} else if(response.data.code == "400") {
							self.$message({
								type: "error",
								message: "操作失败"
							});
						} else {
							self.ifLogin();
						}
						//console.log(response);
						self.HomeworkListData = response.data.data;
						console.log(self.HomeworkListData);
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			HomeworkListEdit(index, row) {
				this.lessonsform.id = row.id;
				this.getDataHomeworkList(row.id);
			},
			reviewListEdit: function(index, row) {
				this.lessonsform.id = row.id;
				this.getreviewData(row.id)
			},
			handleHomeworkDataChange(val) {
				console.log(val);
				this.Homeworkform.id = val.id;
				var reoptions = document.getElementById("btn_options");

				function hasClass(elements, cName) {
					return !!elements.className.match(
						new RegExp("(\\s|^)" + cName + "(\\s|$)")
					); // ( \\s|^ ) 判断前面是否有空格 （\\s | $ ）判断后面是否有空格 两个感叹号为转换为布尔值 以方便做判断
				}

				function removeClass(elements, cName) {
					if(hasClass(elements, cName)) {
						elements.className = elements.className.replace(
							new RegExp("(\\s|^)" + cName + "(\\s|$)"),
							" "
						); // replace方法是替换
					}
				}
				/*reoptions.disabled = false;
				removeClass(reoptions, "is-disabled");*/
			},
			HomeworkEdit(index, row) {
				var self = this;
				self.Homeworkform.question = row.question;
				self.Homeworkform.sort = row.sort;
				self.Homeworkform.detailid = row.detailid;
				self.Homeworkform.id = row.id;
				self.Homeworkform.answer = row.answer;
				self.Homeworkform.analysis = row.analysis;
			},
			//form 表单 数据
			clearHomeworkList() {
				var self = this;
				self.Homeworkform.question = "";
				self.Homeworkform.sort = "";
				self.Homeworkform.fid = self.lessonsform.id;
				self.Homeworkform.id = "";
				self.Homeworkform.answer = "";
				self.Homeworkform.analysis = "";
			},
			submitHomework(formName) {
				console.log(formName);
				var self = this;

				self.axios.post("/homework/add", formName)
					.then(function(response) {
						console.log(response);
						if(response.data.code == "600") {
							self.$message({
								message: "添加/编辑成功",
								type: "success"
							});
							self.getDataHomeworkList(self.lessonsform.id);
						} else if(response.data.code == "400") {
							self.$message({
								type: "error",
								message: "操作失败"
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},

			HomeworkDelete(rows, row, index) {
				var self = this;
				self
					.$confirm("确认删除课后题信息?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(() => {
						self.axios.post("/homework/delete", {
								mark: localStorage.getItem("mark"),
								id: row.id
							})
							.then(function(response) {
								if(response.data.code == "600") {
									self.$message({
										message: "删除成功",
										type: "success"
									});
									self.getDataHomeworkList(self.lessonsform.id);
								} else if(response.data.code == "400") {
									self.$message({
										type: "error",
										message: "操作失败"
									});
								}
							})
							.catch(function(error) {
								console.log(error);
							});
					})
					.catch(() => {
						self.$message({
							type: "info",
							message: "已取消删除"
						});
					});
			},
			submitoptions(formName) {
				console.log(formName);
				var self = this;
				self.axios.post("/options/add", formName)
					.then(function(response) {
						if(response.data.code == "600") {
							self.$message({
								message: "添加/编辑成功",
								type: "success"
							});
						} else if(response.data.code == "400") {
							self.$message({
								type: "error",
								message: "操作失败"
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			clearoptions() {
				var self = this;
				self.optionsform.state = "";
				self.optionsform.sort = "";
				self.optionsform.fid = self.Homeworkform.id;
				self.optionsform.id = "";
				self.optionsform.abcd = "";
			},
			optionsDelete(rows, row, index) {
				var self = this;
				self.$confirm("确认删除选项信息?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(() => {
						self.axios.post("/options/delete", {
								mark: localStorage.getItem("mark"),
								id: row.id
							})
							.then(function(response) {
								if(response.data.code == "600") {
									self.$message({
										message: "删除成功",
										type: "success"
									});
								} else if(response.data.code == "400") {
									self.$message({
										type: "error",
										message: "操作失败"
									});
								} else {
									self.ifLogin();
								}

							})
							.catch(function(error) {
								console.log(error);
							});
					})
					.catch(() => {
						self.$message({
							type: "info",
							message: "已取消删除"
						});
					});
			},
			optionsEdit(index, row) {
				var self = this;
				self.optionsform.state = row.state;
				self.optionsform.sort = row.sort;
				self.optionsform.fid = row.fid;
				self.optionsform.id = row.id;
				self.optionsform.abcd = row.abcd;
			},
			addMoreDetail: function() {
				var that = this;
				var temp = {
					"id": '',
					"lessonsid": that.lessonsform.id,
					"sort": that.conBox.length + 1,
					"en_content": "",
					"ch_content": "",
					"createtime": '',
					"enable": ""
				}
				that.conBox.push(temp);

			},
			delateDetail: function(_id, index) {
				var self = this;
				if(_id === "") {
					self.lessonsform.lessonDetail.splice(index, 1)
				} else {
					self.axios.post("/lessonsDetail/delete", {
							id: _id
						})
						.then(function(response) {
							if(response.data.code == "600") {
								self.conBox.splice(index, 1);
								self.$message({
									message: "删除成功",
									type: "success"
								});
							} else if(response.data.code == "400") {
								self.$message({
									type: "error",
									message: "操作失败"
								});
							}
						})
						.catch(function(error) {
							console.log(error);
						});
				}
				/*if(_id){

				}else{

				}*/

			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.showPrevData {
		position: relative;
		height: 30px;
	}

	.showPrevData .prve_btn {
		position: absolute;
		right: 0;
		top: 0;
	}

	.el-header {
		position: relative;
	}

	.el-header h2 {
		margin: 0;
		line-height: 60px;
	}

	.el-header #btn_add {
		position: absolute;
		right: 25px;
		top: 12px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #67c23a;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 100%;
		display: block;
	}

	.Saveid {
		cursor: pointer;
		color: #67c23a;
		display: block;
	}

	.load_page {
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
	}

	.load_page /deep/ .el-icon-loading {
		font-size: 30px;
	}

	._detail h2 {
		font-weight: 500;
		color: #000;
		font-size: 16px;
	}

	._detail .el-icon-delete {
		position: absolute;
		left: 50px;
		top: 0;
		line-height: 40px;
		font-size: 20px;
		color: #d00;
	}

	._detail .el-icon-delete:hover {
		color: #f33030;
		cursor: pointer;
	}

	.clearfix:after,
	#container:after {
		content: "\0020";
		display: block;
		height: 0;
		clear: both;
		visibility: hidden;
		overflow: hidden
	}
</style>



// WEBPACK FOOTER //
// src/components/product.vue